import { FolderModel } from '../store/schema/FolderModel';
import { getStore } from '../store/store';
import { isLoading } from './loadingSelectors';

export function getFolderModelForId(folderId: string): FolderModel | null {
    const [folderModel] = getStore().folders.filter(folder => folder.id === folderId);

    return folderModel || null;
}

export function getAllFolderModels(): FolderModel[] {
    return getStore().folders;
}

export function isEmptyListOfFolders(): boolean {
    // We consider it to be empty list of folder if we are not loading
    // anymore and the list of folder we have is 0
    return !isLoading() && getAllFolderModels().length === 0;
}
